import React from 'react';
import { useCorporateFields } from 'src/components/enterprise/features/Corporate/components/CorporateFieldsData/hooks/useCorporateFields';
import { CorporateFieldsContext } from 'src/components/enterprise/features/Corporate/components/CorporateFieldsData/CorporateFieldsContext';

export const CorporateFieldsProvider: React.FC = ({ children }) => {
  const { corpFieldsData, loading } = useCorporateFields();

  return (
    <CorporateFieldsContext.Provider value={{ corpFieldsData, loading }}>
      {children}
    </CorporateFieldsContext.Provider>
  );
};
